import { render, staticRenderFns } from "./SfRadio.vue?vue&type=template&id=39086323&scoped=true&"
import script from "./SfRadio.vue?vue&type=script&lang=js&"
export * from "./SfRadio.vue?vue&type=script&lang=js&"
import style0 from "./SfRadio.vue?vue&type=style&index=0&id=39086323&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39086323",
  null
  
)

export default component.exports